/*
Akhila 11/19/2022 2700271704 Created new Component
Rohini  12/05/2022 2700271704 changed side nav format
Ashraf 12/05/2022 2700271704 Fixed header labels
sai krishna  1/2/2023 2700271704 renamed tabLabels
*/
import React from 'react';
import Tabs from './Tabs';
import LandingPage from '../../../Pages/LandingPage';


function SearchAccountTrigger() {
  const [value, setValue] = React.useState(0);

  // set Tab Value(2699758070)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Account Update '];

  return (
    <>
      <LandingPage title={'Triggers'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
        <div className={`global-field-dash-board`}>
          <div>
            <div>
              <Tabs value={value} />
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default SearchAccountTrigger;
